/**
 * DiagnosisUnlockFlow 布局 token — 字面映射 Figma，避免 magic number 散落。
 */

/**
 * DiagnosisUnlockFlow 布局 token — 字面映射 Figma，避免 magic number 散落。
 */

/** Figma `90772:39541` — iOS 状态栏占位高度（px） */
export const DIAGNOSIS_UNLOCK_STEP2_H5_STATUS_BAR_PX = 46;

/** Figma `90772:39508` — H5 Step2 内容区距屏幕顶（含状态栏） */
export const DIAGNOSIS_UNLOCK_STEP2_H5_CONTENT_TOP_PX = 127;

/**
 * Figma 推导：127 − 46 = 81px，标题距状态栏下沿。
 * 实现：`padding-top: calc(env(safe-area-inset-top) + 81px)`，全屏 Modal 无系统状态栏时由 safe-area 顶替。
 */
export const DIAGNOSIS_UNLOCK_STEP2_H5_HEADLINE_OFFSET_BELOW_SAFE_PX =
  DIAGNOSIS_UNLOCK_STEP2_H5_CONTENT_TOP_PX -
  DIAGNOSIS_UNLOCK_STEP2_H5_STATUS_BAR_PX;

/** Figma `90772:39508` — H5 内容最大宽度 */
export const DIAGNOSIS_UNLOCK_STEP2_H5_CONTENT_MAX_WIDTH_PX = 345;

/** Figma `90772:39508` — H5 headline ↔ findings，40px */
export const DIAGNOSIS_UNLOCK_STEP2_H5_PANEL_GAP_CLASS = "gap-10";

/** Figma `90772:43091` — PC headline ↔ findings，24px */
export const DIAGNOSIS_UNLOCK_STEP2_PC_PANEL_GAP_CLASS = "gap-6";

/** Figma `90772:43090` — PC 内容区 ↔ 底部 CTA，40px */
export const DIAGNOSIS_UNLOCK_STEP2_PC_CTA_TOP_CLASS = "pt-10";
